import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14c82228")

_pushScopeId("data-v-14c82228")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = { class: "top-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sub-title" }
const _hoisted_5 = { class: "nav-wrapper" }
const _hoisted_6 = { class: "content-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.modules.top.title), 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.modules.top.subTitle), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              key: k,
              class: `nav-item ${k === _ctx.currentNav ? 'active' : ''}`,
              onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
            }, [
              _createVNode("span", null, _toDisplayString(i.title), 1)
            ], 10, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentNav].imgs, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              key: k,
              class: "content-item"
            }, [
              _createVNode(_component_ImgContainer, { src: i }, null, 8, ["src"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})